let currentLocation = window.location
let currentOrigin = process.env.REACT_APP_MIDDLEWARE_URL || "https://flex-prod-middleware-bphgfya0dvbvbpc4.uaenorth-01.azurewebsites.net"
const integrationFrontendHost = process.env.REACT_APP_INTEGRATION_FRONTEND_HOST || ''
const companyDomainHosts = (process.env.REACT_APP_COMPANY_DOMAIN_HOSTS || '').split(',').map(h => h.trim()).filter(Boolean)
const tenantLoginDomain = process.env.REACT_APP_TENANT_LOGIN_DOMAIN || 'lynkaz.com'
const supportLoginUrl = process.env.REACT_APP_SUPPORT_LOGIN_URL || (integrationFrontendHost ? `https://${integrationFrontendHost}/login` : '/login')

const location = origin;
const parsedUrl = new URL(location);
const hostnameParts = parsedUrl.hostname.split('.');
const subdomain = hostnameParts[0];

let Settings = {  
    apiUrl: currentLocation?.hostname === `${subdomain}.localhost` ? `https://${subdomain}.azurewebsites.net/api` : `${currentOrigin}/api`, 
    apiAppUrl: currentLocation?.hostname === `${subdomain}.localhost` ? `https://${subdomain}.azurewebsites.net/api/apps` : `${currentOrigin}/api/apps`, 
    defaultLang:'en',
    userTokenKey:'lynkaq_user_token',
    dateFormateKey:'lynkaq_dateformate',
    tenantSubdomain:'tenant_subdomain',
    languageKey:'app_lang',
    userTokenExpireDate:1,
    integrationFrontendHost,
    companyDomainHosts,
    tenantLoginDomain,
    supportLoginUrl,
    toDynamics: Number(process.env.REACT_APP_TO_DYNAMICS_APP_ID || 2284924),
    toLynkaz: Number(process.env.REACT_APP_TO_LYNKAZ_APP_ID || 5),
    enumStatus: [ // this will be removed when api arrives
        {value: '0', label: 'Active'},
        {value: '1', label: 'Non active'}
    ],
    apiNamesEnum: [
        { value: 250, label: "Notification" },
        { value: 1, label: "Payment Terms" },
        { value: 2, label: "Legal Entity" },
        { value: 6, label: "Vendor Group" },
        { value: 3, label: "Site" },
        { value: 4, label: "Warehouse" },
        { value: 7, label: "Fiscal Calendar" },
        { value: 36, label: "Currency" },
        { value: 9, label: "Purchase Requisition" },
        { value: 83, label: "Pr Budget Check" },
        { value: 84, label: "PO Budget Check" },
        { value: 27, label: "Unit" },
        { value: 28, label: "Unit Of Conversion" },
        { value: 12, label: "Purchase Order" },
        { value: 13, label: "Release Order" },
        { value: 14, label: "Contract" },
        { value: 15, label: "Terms Of Delivery" },
        { value: 17, label: "Sales Tax Group" },
        { value: 19, label: "Item Sales Tax Group" },
        { value: 25, label: "User" },
        { value: 18, label: "Employee" },
        { value: 23, label: "Category" },
        { value: 52, label: "Segment Values" },
        { value: 24, label: "Language" },
        { value: 54, label: "Shipments" },
        { value: 16, label: "Invoices" },
        { value: 86, label: "Good Receiving" },
        { value: 87, label: "Work Confirmation" },
        { value: 47, label: "Currency Conversion" },
        { value: 48, label: "Currency Conversion Rates" },
        { value: 107, label: "Item Group" },
        { value: 108, label: "Item" }
    ],
    httpMethodOptions: [
        { value: "GET", label: "Get" },
        { value: "POST", label: "Post" },
        { value: "PUT", label: "Update" },
        { value: "DELETE", label: "Delete" }
    ],
    enumStatusDataQueue: [ // this will be removed when api arrives
        {value: '0', label: 'In Queue'},
        {value: '1', label: 'In Progress'},
        {value: '3', label: 'Success'},
        {value: '4', label: 'Error'},
    ],
    redirectUrlAfterLogin:'system-integration',
    loginLink:'login',
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    debug: process.env.REACT_APP_DEBUG === 'true',
    defaultDateFormate:'mm/dd/yyyy',
}

export default Settings;